<template>
  <section class="section is-medium">
      <!-- <div class="container"> -->
          <div class="columns is-centered">
              <div class="column is-4">
                  <div class="section box">
                    <b-icon pack="fas" icon="user" size="is-large"></b-icon>
                    <b-field label="Nombre">
                        <b-input v-model="nombre"></b-input>
                    </b-field>
                    <b-field label="Contraseña">
                        <b-input v-model="pass" type="password" password-reveal></b-input>
                    </b-field>
                    <div class="buttons">
                        <b-button tag="router-link" :to="{ path: '/signup' }" type="is-primary" expanded>Crear cuenta</b-button>
                        <b-button type="is-success" expanded>Entrar</b-button>
                    </div>
                </div>
              </div>
          </div>
      <!-- </div> -->
  </section>
</template>

<script>
export default {
    name: 'Login',
    data() {
        return {
            nombre: '',
            pass: ''
        }
    }
}
</script>

<style>

</style>